import { routesInApi } from '../../constants/routes';
import {
  movieLog,
  pageChangeLog,
  IncreaseUserSession,
} from '../../services/log';
import { types } from '../../types';
import errorException from '@/helpers/errorException';

export const logs = {
  async logChangePage({ getters, commit }, { from, to }) {
    commit(types.SET_LOADING, { logChangePage: true });
    try {
      const userSessionId = getters.getUserSessionId;
      const pageNames = routesInApi.map(({ name }) => name);

      const Direction =
        pageNames.indexOf(to) - pageNames.indexOf(from) > 0
          ? 'Forward'
          : 'Back';
      const PageType = routesInApi.find((page) => page.name === to).api;

      if (
        to !== 'BeforePage' &&
        to !== 'generalSchedule' &&
        to !== 'filmSchedule'
      )
        await pageChangeLog({ PageType, Direction }, userSessionId);
    } catch (e) {
      errorException(e, commit, 'logChangePage');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { logChangePage: false });
    }
  },

  async logTicket({ commit, getters, state }, { place, type, index }) {
    try {
      if (state.cart.tickets.length === 10) {
        if (state.promoData) {
          commit(types.CLEAR_PROMO_CODE_DATA);
        }
      }

      if (type === 'AddItem') {
        commit(types.ADD_PLACE_TO_CART, { place });
      } else if (type === 'RemoveItem') {
        commit(types.REMOVE_PLACE_FROM_CART, index);
      }

      commit(types.ADD_TO_REMOVED_PLACES_LIST, place);

      const userSessionId = getters.getUserSessionId;

      await movieLog(
        {
          ChangedItem: {
            Id: place.id,
            TypeId: state.places.find(({ Id }) => Id === place.id).TypeId,
            Row: place.row,
            Number: place.number,
            VariantId: place.typeId,
          },
          ChangeType: type,
        },
        userSessionId,
      );
    } catch (e) {
      errorException(e, commit, 'logTicket');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { logTicket: false });
    }
  },

  async logBack({ commit, getters }) {
    try {
      commit(types.SET_LOADING, { logBack: true });
      const userSessionId = getters.getUserSessionId;
      await IncreaseUserSession(userSessionId);
    } catch (e) {
      errorException(e, commit, 'logBack');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { logBack: false });
    }
  },

  async logBackToGeneralSchedule({ getters, commit }) {
    try {
      const userSessionId = getters.getUserSessionId;
      await pageChangeLog(
        { PageType: 'ToGeneralSchedule', Direction: 'Back' },
        userSessionId,
      );
    } catch (e) {
      errorException(e, commit, 'logBackToGeneralSchedule');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { logBackToGeneralSchedule: false });
    }
  },
};
